//
// CallControls - Main call controls wrapper component
// Handles active call state and provides SingleCaseProvider context
//
import PropTypes from 'prop-types';

import {
  useCalls,
  useTownConfig,
} from '../../stores';
import SingleCaseProvider from '../../stores/singleCase/SingleCaseProvider';

import CallControlsDisplay from './CallControlsDisplay';

function CallControls(props) {
  const {
    setCaseSelected,
  } = props;
  const { calls } = useCalls() || {};
  const { townConfig } = useTownConfig();

  // console.log(`calls=${displayJson(calls, 1)}`);
  // console.log(`townConfig=${displayJson(townConfig, 1)}`);

  if (!calls?.active?.csid) return null;

  return (
    <div className="flex items-center justify-center bg-transparent absolute w-full bottom-0 z-1000 pointer-events-none">
      <div className="bg-pxInitBgnd text-pxMainMenuItemSel flex flex-col items-center justify-center text-sm font-normal rounded-t-md border-t border-l border-r border-white/25 border-solid overflow-hidden shadow-button pointer-events-auto">
        <SingleCaseProvider
          caseSelected={{
            cuid: calls.active.cuid,
            csid: calls.active.csid,
          }}
          cstmrType={townConfig.cstmrType}
        >
          <CallControlsDisplay setCaseSelected={setCaseSelected} />
        </SingleCaseProvider>
      </div>
    </div>
  );
}

CallControls.propTypes = {
  setCaseSelected: PropTypes.func.isRequired,
};

export default CallControls;
